module.exports = __webpack_public_path__ + "static/media/icon-shar-hosp.ca6fa49d.svg";